import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AuthPage from "@/pages/AuthPage";
import Workspace from "@/pages/Workspace";
import SharePage from "@/pages/SharePage";
import { ForgotPasswordPage, ResetPasswordPage } from "@/pages/PasswordPages";

const ResetRoute = () => {
  const { setUser } = useAuth();
  return <ResetPasswordPage onAuthed={setUser} />;
};

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="h-full flex items-center justify-center" data-testid="auth-loading">
        <div className="flex gap-1.5"><span className="typing-dot" /><span className="typing-dot" /><span className="typing-dot" /></div>
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return children;
};

const PublicOnly = ({ children }) => {
  const { user } = useAuth();
  if (user) return <Navigate to="/" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<PublicOnly><AuthPage /></PublicOnly>} />
            <Route path="/register" element={<Navigate to="/login" replace />} />
            <Route path="/s/:token" element={<SharePage />} />
            <Route path="/forgot-password" element={<PublicOnly><ForgotPasswordPage /></PublicOnly>} />
            <Route path="/reset-password" element={<ResetRoute />} />
            <Route path="/" element={<Protected><Workspace /></Protected>} />
            <Route path="/c/:id" element={<Protected><Workspace /></Protected>} />
            <Route path="/gallery" element={<Protected><Workspace view="gallery" /></Protected>} />
            <Route path="/compare" element={<Protected><Workspace view="compare" /></Protected>} />
            <Route path="/studio" element={<Protected><Workspace view="studio" /></Protected>} />
            <Route path="/admin" element={<Protected><Workspace view="admin" /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="bottom-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
